$(".passwordReveal").on("click", function (e) {
    e.preventDefault();
    var passwordButton = $(this);
    var passwordInput = passwordButton.siblings('input');
    if (passwordInput.hasClass('__active')) {
        passwordInput.removeClass('__active');
        passwordButton.removeClass('__active');
        passwordInput.attr('type', 'password');
    } else {
        passwordButton.addClass('__active');
        passwordInput.addClass('__active');
        passwordInput.attr('type', 'text');
        passwordInput.focus();
    }
});